import WashdayClientSingleton from './WashdayClientSingleton';

export const getOrderPublicReceipt = async (publicToken: string) => {
    try {
        return await WashdayClientSingleton.getInstance().publics.getOrderPublicReceipt(publicToken);
    } catch (e) {
        console.log('ERROR getOrderPublicReceipt', e);
        throw e;
    }
};